import React from 'react';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-[90vh] flex items-center justify-center pt-14 overflow-hidden" data-id="element-174">
      <div className="absolute inset-0 z-0" data-id="element-175">
        <img src="https://cdn.magicpatterns.com/uploads/wxb9hfYp8tW2YRmeYVAeCP/heylloyd-image-1774743262443.png" alt="Construction Professional" className="w-full h-full object-cover object-[30%_center] sm:object-center" data-id="element-176" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-bg-dark/50 via-brand-bg-dark/20 to-transparent" data-id="element-177"></div>
        <div className="absolute inset-0 bg-black/10" data-id="element-178"></div>
      </div>
    </section>;
}